export const theme = {
    
    type: 'light',
    primary: '#000000',
    primary400: '#000000',
    primary600: '#000000',
    primary80: '#000000cc',
    primary50: '#00000080',
    primary30: '#0000004d',
    secondary: '#EAEAEA',
    secondary70: '#EAEAEAb3',
    secondary50: '#EAEAEA80',
    tertiary: '#212121',
    tertiary80: '#212121cc',
    tertiary70: '#212121b3',
    tertiary50: '#21212180',

    // type: 'dark',
    // primary: '#545fc4',
    // primary400: '#6e76c7',
    // primary600: '#3644c9',
    // primary80: '#545fc4cc',
    // primary50: '#545fc480',
    // primary30: '#545fc44d',
    // secondary: '#212121',
    // secondary70: '#212121b3',
    // secondary50: '#21212180',
    // tertiary: '#eaeaea',
    // tertiary80: '#eaeaeacc',
    // tertiary70: '#eaeaeab3',
    // tertiary50: '#eaeaea80',
    // aboutimg1: blueThemeboy,
    // aboutimg2: blueThemegirl,
    // eduimg: eduBlue,
    // expimg: expBlue,
    // contactsimg: contactsBlue





    // type: 'dark',
    // primary: '#B6B6B6',
    // primary400: '#B6B6B6',
    // primary600: '#B6B6B6',
    // primary80: '#B6B6B6cc',
    // primary50: '#B6B6B680',
    // primary30: '#B6B6B64d',
    // secondary: '#212121',
    // secondary70: '#212121b3',
    // secondary50: '#21212180',
    // tertiary: '#eaeaea',
    // tertiary80: '#eaeaeacc',
    // tertiary70: '#eaeaeab3',
    // tertiary50: '#eaeaea80',


       

    
}